// removed by extract-text-webpack-plugin
module.exports = {"titleWrapper":"Title__titleWrapper___3Go9f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ControlPanel/Title/Title.css
// module id = 945
// module chunks = 0